export class PSettingItem {
  constructor(
    public id: string,
    public name: string,
    public icon: string,
    public route: null | string,
    public isVisible: boolean | null = null,
    public children: PSettingItem[] = [],
  ) {
    this.isVisible ??= children.some((child) => child.isVisible)
  }
}
